import { useAccountTypeStructures } from "@features/tickets/shared/hooks/useAccountTypeStructures";
import { CASH_BOX_ACCOUNT_TYPE } from "./cashBoxes.constants";

export function useCashBoxStructures() {
  return useAccountTypeStructures(CASH_BOX_ACCOUNT_TYPE);
}
